import { reaction as mobxReaction } from 'mobx';
import { deepObserve, IDisposer } from 'mobx-utils';

export class ReactionManager {
  protected _reactions: IDisposer[] = [];

  protected reaction: typeof mobxReaction = (...args) => {
    const disposer = mobxReaction(...args);
    this._reactions.push(disposer);
    return disposer;
  };

  protected deepObserve: typeof deepObserve = (...args) => {
    const disposer = deepObserve(...args);
    this._reactions.push(disposer);
    return disposer;
  };

  deinit() {
    this._reactions.forEach((dispose) => dispose());
  }
}
